var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandLinktree = function SvgBrandLinktree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "m12.949 6.523 3.84-3.95 2.23 2.284L14.99 8.7h5.667v3.172h-5.694l4.056 3.942-2.23 2.24-5.505-5.537-5.506 5.536-2.23-2.23 4.056-3.942H1.91V8.7h5.667L3.55 4.856l2.229-2.284 3.84 3.95V.906h3.33zm-3.33 9.89h3.33v7.526h-3.33z"
  })));
};
export default SvgBrandLinktree;